import { render, staticRenderFns } from "./social-login.vue?vue&type=template&id=0546a814"
import script from "./social-login.vue?vue&type=script&lang=js"
export * from "./social-login.vue?vue&type=script&lang=js"
import style0 from "./social-login.vue?vue&type=style&index=0&id=0546a814&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./social-login.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports